import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios'
import { StorageUtils } from '../../../store/Verification'
import { VerificationState } from '../verification.slice'
import { SippApi } from '../../../services/SippExpress'

export const verifyOtpAsync = createAsyncThunk(
  'verification/verifyOtp',
  async ({ email, otp }: { email: string; otp: string }, { rejectWithValue }) => {
    try {
      const response = await SippApi.verifyOtp(email, otp)
      return (response as AxiosResponse<any>).data
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || 'Failed to verify OTP')
    }
  },
)

export const verifyOtpAsyncBuilder = (builder: ActionReducerMapBuilder<VerificationState>) => {
  builder
    .addCase(verifyOtpAsync.pending, (state) => {
      state.verifyLoading = true
      state.error = null
      state.message = null
      state.token = ''
    })
    .addCase(verifyOtpAsync.fulfilled, (state, action: PayloadAction<any>) => {

      state.verifyLoading = false
      state.isVerified = true
      state.verifiedEmail = action.payload.user.email
      state.message = action.payload.message
      state.token = action.payload.token

    })
    .addCase(verifyOtpAsync.rejected, (state, action: PayloadAction<any>) => {
      state.verifyLoading = false
      state.error = action.payload.error
    })
}
